<div class="flex-content">
  <div class="content col-sm-12 container-fluid">

    <div *ngFor="let project of projects$ | async" class="row project-list no-gutters">

      <div class="col-sm-12 project-year display-4" [id]='project[0].start'>
        {{project[0].start}}

      </div>

      <div *ngFor="let project of project" class="col-sm-12 project">
        <!-- <a [routerLink]="[ '/main/projects/individual/', project.id ]" class="col-sm-12 project-title h2">
          {{project.name}}
        </a> -->

        <div class="col-sm-12 col-lg-6 project-desc">
          <a [routerLink]="[ '/main/projects/individual/', project.id ]" class="col-sm-12 project-title h2">
            {{project.name}}
          </a>
          <table class="table menu01">
            <tbody>

              <tr>
                <td class="table-year">Full name</td>
                <td>
                  {{project.fullname}}
                </td>
              </tr>

              <ng-container *ngIf="project.team">
                <tr>
                  <td class="table-year">{{teamNameTitle(project.team?.shortname[0])}}</td>
                  <td>
                    <span *ngFor="let name of project.team.shortname" style="margin-right:15px">
                      {{name}}
                    </span>
                    <!-- {{project.team?.shortname}} -->
                  </td>
                </tr>
              </ng-container>
              
              <ng-container *ngIf="project.area">
                <tr>
                  <td class="table-year">Area</td>
                  <td *ngIf="project.area">
                    {{project.area}}
                  </td>
                </tr>
              </ng-container>

              <ng-container *ngIf="project.partners">
                <tr>
                  <td class="table-year">Partners</td>
                  <td *ngIf="project.partners">
                    {{ project.partners[0]?.name }}
                  </td>
                </tr>
              </ng-container>

              <ng-container *ngIf="project.funding">
                <tr>
                  <td class="table-year">Funding</td>
                  <td *ngIf="project.funding">
                    {{ project.funding?.name }}
                  </td>
                </tr>
              </ng-container>

              <tr>
                <td class="table-year">Manager</td>
                <!-- <td *ngIf="project.funding">
                  {{ project.funding?.name }}
                </td> -->
                <td>
                  <span *ngFor="let person of project.people" style="margin-right:15px">
                    <a [routerLink]='["../people", "person", person.id]'>{{person.name}}</a>
                  </span>
                </td>
              </tr>

            </tbody>
          </table>
        </div>

        <div class="col-sm-12 col-lg-6 project-img" (click)="navigateTo(project.id)">
          <!-- <img src="./../../../../assets/Contents/imgs/no_image.jpg" >  -->
          <img default="./../../../../assets/Contents/imgs/no_image.jpg"
              [srcset]= 'imgPath +project.teaser_img'
              [src]= 'imgPath +project.teaser_img'>
        </div>


        <!-- <div class="col-sm-12 col-md-6 col-lg-2 project-funding">
          <hr/>
          <p class="menu01">Manager</p>
          <div *ngFor="let person of project.people">
            <a [routerLink]='["../people", "person", person.id]'>{{person.name}}</a>
          </div>
        </div> -->

      </div>


      <hr/>
    </div>

    <!--<ngb-pagination class="pagination" [masmize]="5" [collectionSize]="170"  [(page)]="page" [boundaryLinks]="true"></ngb-pagination>-->

  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/research-projects/research-projects.component.html